<template>
  <div class="emap-flow-modal-distributeSubmit">
    <Modal v-model="visible" :title="options.name" :mask-closable="false">
      <div class="container">
        <Form :model="distributeForm" ref="distributeForm" :rules="ruleValidate" :label-width="100">
          <FormItem :label="$LocalH5('recipient')" prop="assignee">
            <div class="ivu-input-wrapper">
              <div class="ivu-input-copy" @click="personPick = true">
                <Tag 
                  type="border" 
                  color="blue" 
                  v-for="(item, index) in assignees" 
                  :name="item.id" 
                  :key="index" 
                  closable
                  @on-close="delItem(item,index)"
                >{{item.name}}</Tag>
              </div>
              <Select v-model="distributeForm.assignee" multiple v-show="false" disabled>
                <Option v-for="(item, index) in assignees" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select>
            </div>
          </FormItem>
          <FormItem :label="$LocalH5('distributeInstru')" prop="desc">
            <Input v-model="distributeForm.desc" type="textarea" :rows="4" :placeholder="$LocalH5('validDistriInstr')" />
          </FormItem>
          <FormItem :label="$LocalH5('pageView.msgType')" prop="way">
            <CheckboxGroup v-model="distributeForm.way">
              <Checkbox v-for="item in ways" :key="item.code" :label="item.code">
                <span>{{ item.name }}</span>
              </Checkbox>
            </CheckboxGroup>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button size="large" @click="visible = false">{{$LocalH5('buttonCancel')}}</Button>
        <Button type="primary" size="large"  @click="onConfirm('distributeForm')">{{$LocalH5('buttonConfirm')}}</Button>
      </div>
    </Modal>
    <emap-flow-pick 
      v-model="personPick" 
      :options="distributeForm.assignee" 
      multiple 
      @on-confirm="onPickConfirm"
    ></emap-flow-pick>
  </div>
</template>
<script>
import api from '@/api/toolbar'
import EmapFlowPick from '../emap-flow-pick.vue'

export default {
  name: "hand-out",
  components: {
    EmapFlowPick
  },
  data() {
    return {
      visible: false,
      personPick: false,
      ways: [],
      distributeForm: {
        assignee: [],
        desc: '',
        way: []
      },
      ruleValidate: {
        assignee: [
          { required: true, type: 'array', min: 1, message: this.$LocalH5('chooseRecipient'), trigger: 'change' }
        ],
        desc: [
          { required: true, message: this.$LocalH5('validDistriInstru'), trigger: 'blur' }
        ],
        way: [
          { required: true, type: 'array', min: 1, message: this.$LocalH5('pageView.validCodeMsg'), trigger: 'change' }
        ]
      },
      assignees: []
    }
  },
  props: {
    value: Boolean,
    options: {
      type: Object,
      default: () => {
        return {
          name: ''
        }
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val;
      if(val) this.init();
    },
    visible(val) {
      if(!val) this.$emit('input', false);
    },
  },
  methods: {
    init() {
      this.distributeForm.assignee = [];
      this.distributeForm.desc = '';
      this.distributeForm.way = [];
      this.assignees = [];
      this.$refs['distributeForm'].resetFields();
    },
    onConfirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-confirm', {
            distributeDesc: this.distributeForm.desc,
            messageType: this.distributeForm.way.join(''),
            toUsers: this.distributeForm.assignee.join(',')
          });
          this.visible = false;
        }
      })
    },
    delItem(item,index) {
      this.assignees.splice(index,1);
      this.distributeForm.assignee = this.distributeForm.assignee.filter(value => value !== item.id);
    },
    onPickConfirm(ids, items) {
      this.assignees = items;
      this.distributeForm.assignee = ids;
    }
  },
  mounted() {
    api.querySendMsgWays().then(res => {
      if(res && res.messageType) {
        this.ways = res.messageType.filter(type => type.code !== '7')
      }
    })
  }
};
</script>
<style>
  .ivu-input-copy {
    display: inline-block;
    width: 100%;
    min-height: 38px;
    max-height: 100px;
    overflow-y: auto;
    line-height: 1.5;
    padding: 4px 7px;
    font-size: 14px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: pointer;
    -webkit-transition: border .2s ease-in-out,background .2s ease-in-out,-webkit-box-shadow .2s ease-in-out;
    transition: border .2s ease-in-out,background .2s ease-in-out,-webkit-box-shadow .2s ease-in-out;
    transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
    transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out,-webkit-box-shadow .2s ease-in-out;
  }
</style>